<via-error>
  <h1>Your network is currently offline</h1>

  <h3>Please try again when you have a stable internet connection</h3>

  <via-error-actions></via-error-actions>
</via-error>
